'use client';

import { AppProgressBar } from 'next-nprogress-bar';

const ProgressBar = () => (
  <AppProgressBar
    color='#ff794d'
    height='8px'
    options={{ showSpinner: false, minimum: 0.1, trickleSpeed: 100 }}
    shallowRouting
  />
);

export default ProgressBar;
